import React, { useEffect, useState } from "react";
import HeroSection from "../components/HeroSection";
import Section2 from "../components/Section2";
import Choice from "../components/Choice";
import ProgressSection from "../components/Progress";
import Testimonials from "../components/Testimonials";
import Timing from "../components/Timing";
import Footer from "../components/Footer";
import Locations from "../components/Locations";
import ClientReview from "../components/ClientReview";
import { useLocation, useNavigate } from "react-router";
import config from "../config";
import axios from "axios";
import Loader from "../utils/Loader";
import { Helmet } from "react-helmet";

const HomePage = ({
  locationArray,
  call,
  setLocationName,
  location_name,
  categoryList,
  testimonialsList,
  intsLink,
  fbLink,
  tiktokLink,
  ytLink,
  getTargetLocation,
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  // console.log("home cat", categoryList)
  useEffect(() => {
    if (localStorage.getItem("location") !== null) {
      fetchHomeData();
    }
  }, [location.pathname]);

  const [isLoading, setIsLoading] = useState(false);
  // Banner Section
  const [slide1_title, setSlider1Title] = useState("");
  const [slide2_title, setSlider2Title] = useState("");
  const [slide3_title, setSlider3Title] = useState("");
  const [slide1_description, setSlider1Desc] = useState("");
  const [slide2_description, setSlider2Desc] = useState("");
  const [slide3_description, setSlider3Desc] = useState("");
  const [slide1_middle_image, setSlider1MiddleImg] = useState("");
  const [slide2_middle_image, setSlider2MiddleImg] = useState("");
  const [slide3_middle_image, setSlider3MiddleImg] = useState("");
  const [slide1_left_image, setSlider1LeftImg] = useState("");
  const [slide2_left_image, setSlider2LeftImg] = useState("");
  const [slide3_left_image, setSlider3LeftImg] = useState("");
  const [slide1_right_image, setSlider1RightImg] = useState("");
  const [slide2_right_image, setSlider2RightImg] = useState("");
  const [slide3_right_image, setSlider3RightImg] = useState("");

  // Taste the Magic
  const [taste_title, setTasteTitle] = useState("");
  const [taste_description, setTasteDesc] = useState("");
  const [service_box1_image, setSBox1Img] = useState("");
  const [service_box1_title, setSBox1Title] = useState("");
  const [service_box1_description, setSBox1Desc] = useState("");
  const [service_box2_image, setSBox2Img] = useState("");
  const [service_box2_title, setSBox2Title] = useState("");
  const [service_box2_description, setSBox2Desc] = useState("");
  const [service_box3_image, setSBox3Img] = useState("");
  const [service_box3_title, setSBox3Title] = useState("");
  const [service_box3_description, setSBox3Desc] = useState("");
  const [right_side_image1, setRightImg1] = useState("");
  const [right_side_image2, setRightImg2] = useState("");
  const [right_side_image3, setRightImg3] = useState("");
  const [right_side_video_link, setRightVideoLink] = useState("");

  // Make Every Occasion Sweet
  const [make_title, setMakeTitle] = useState("");
  const [make_description, setMakeDesc] = useState("");
  const [make_satisfied_customers, setSatisCust] = useState("");
  const [make_organic_ingredients, setOrganicIng] = useState("");
  const [make_organic_skilled_icecream_artist, setSkilledArtist] = useState("");
  const [make_image1, setMakeImg1] = useState("");
  const [make_image1_name, setMakeImg1Name] = useState("");
  const [make_image2, setMakeImg2] = useState("");
  const [make_image2_name, setMakeImg2Name] = useState("");

  // Unlock Exclusive Rewards
  const [unlock_title, setUnlockTitle] = useState("");
  const [unlock_description, setUnlockDesc] = useState("");
  const [unlock_left_image, setUnlockLeftImg] = useState("");
  const [unlock_right_image, setUnlockRightImg] = useState("");
  const [unlock_app_store_link, setAppStoreLink] = useState("");
  const [unlock_play_store_link, setPlayStoreLink] = useState("");

  // footer
  const [footer_title, setFooterTitle] = useState("");
  const [footer_description, setFooterDesc] = useState("");
  const [footer_left_image, setFooterLeftImg] = useState("");
  const [footer_right_image, setFooterRightImg] = useState("");

  // Fetting Data
  const fetchHomeData = async () => {
    // setIsLoading(true);
    const formData = new FormData();
    formData.append("location", localStorage.getItem("location"));
    try {
      const response = await axios({
        method: "post",
        url: `${config.apiUrl}/home-data`,
        data: formData,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then((res) => {
        // console.log("res",res)
        setSlider1Title(res.data.data?.slide1_title || "-");
        setSlider2Title(res.data.data?.slide2_title || "-");
        setSlider3Title(res.data.data?.slide3_title || "-");
        setSlider1Desc(res.data.data?.slide1_description || "-");
        setSlider2Desc(res.data.data?.slide2_description || "-");
        setSlider3Desc(res.data.data?.slide3_description || "-");
        setSlider1MiddleImg(res.data.data?.slide1_middle_image || "-");
        setSlider2MiddleImg(res.data.data?.slide2_middle_image || "-");
        setSlider3MiddleImg(res.data.data?.slide3_middle_image || "-");
        setSlider1LeftImg(res.data.data?.slide1_left_image || "-");
        setSlider2LeftImg(res.data.data?.slide2_left_image || "-");
        setSlider3LeftImg(res.data.data?.slide3_left_image || "-");
        setSlider1RightImg(res.data.data?.slide1_right_image || "-");
        setSlider2RightImg(res.data.data?.slide2_right_image || "-");
        setSlider3RightImg(res.data.data?.slide3_right_image || "-");

        setTasteTitle(res.data.data.taste_title || "-");
        setTasteDesc(res.data.data.taste_description || "-");
        setSBox1Img(res.data.data.service_box1_image || "-");
        setSBox1Title(res.data.data.service_box1_title || "-");
        setSBox1Desc(res.data.data.service_box1_description || "-");
        setSBox2Img(res.data.data.service_box2_image || "-");
        setSBox2Title(res.data.data.service_box2_title || "-");
        setSBox2Desc(res.data.data.service_box2_description || "-");
        setSBox3Img(res.data.data.service_box3_image || "-");
        setSBox3Title(res.data.data.service_box3_title || "-");
        setSBox3Desc(res.data.data.service_box3_description || "-");
        setRightImg1(res.data.data.right_side_image1 || "-");
        setRightImg2(res.data.data.right_side_image2 || "-");
        setRightImg3(res.data.data.right_side_image3 || "-");
        setRightVideoLink(res.data.data.right_side_video_link || "-");

        setMakeTitle(res.data.data.make_title || "-");
        setMakeDesc(res.data.data.make_description || "-");
        setSatisCust(res.data.data.make_satisfied_customers || "-");
        setOrganicIng(res.data.data.make_organic_ingredients || "-");
        setSkilledArtist(
          res.data.data.make_organic_skilled_icecream_artist || "-"
        );
        setMakeImg1(res.data.data.make_image1 || "-");
        setMakeImg1Name(res.data.data.make_image1_name || "-");
        setMakeImg2(res.data.data.make_image2 || "-");
        setMakeImg2Name(res.data.data.make_image2_name || "-");

        setUnlockTitle(res.data.data.unlock_title || "-");
        setUnlockDesc(res.data.data.unlock_description || "-");
        setUnlockLeftImg(res.data.data.unlock_left_image || "-");
        setUnlockRightImg(res.data.data.unlock_right_image || "-");
        setAppStoreLink(res.data.data.unlock_app_store_link || "-");
        setPlayStoreLink(res.data.data.unlock_play_store_link || "-");

        setFooterTitle(res.data.data.footer_title || "-");
        setFooterDesc(res.data.data.footer_description || "-");
        setFooterLeftImg(res.data.data.footer_left_image || "-");
        setFooterRightImg(res.data.data.footer_right_image || "-");

        // setIsLoading(false);
      });
    } catch (error) {
      // swal({
      //   icon:"error",
      //   text:"Something went wrong."
      // })
      // setIsLoading(false);
      console.log("Home Page Data error", error);
    }
  };

  // console.log("HOmne", categoryList);

  return (
    <>
      <Helmet>
        <title>
          Rolled Ice Cream- Canada&#039;s Best Desserts Shop Near Me
        </title>
        <meta name="keywords" content="rolled ice cream," />
        <meta
          name="title"
          content="Rolled Ice Cream- Canada's Best Desserts Shop Near Me"
        />
        <meta
          name="description"
          content="Rollz stands as the best Rolled Ice Cream and Delicious Desserts shop in Toronto. We take pride in serving cheesecake, Belgian waffles, ice cream cake, milkshakes, etc."
        />
        <meta
          property="og:title"
          content="Enjoy Yummy Ice Cream And Desserts Blog | Rollz Ice Cream"
        />
        <meta
          property="og:description"
          content="Discover a treasure trove of blog content covering ice cream recipe, what is and how to make cheesecake, and much more. Feel free to explore more."
        />
      </Helmet>
      {/* {isLoading && <Loader />} */}
      <div>
        <HeroSection
          slide1_title={slide1_title}
          slide2_title={slide2_title}
          slide3_title={slide3_title}
          slide1_description={slide1_description}
          slide2_description={slide2_description}
          slide3_description={slide3_description}
          slide1_middle_image={slide1_middle_image}
          slide2_middle_image={slide2_middle_image}
          slide3_middle_image={slide3_middle_image}
          slide1_left_image={slide1_left_image}
          slide2_left_image={slide2_left_image}
          slide3_left_image={slide3_left_image}
          slide1_right_image={slide1_right_image}
          slide2_right_image={slide2_right_image}
          slide3_right_image={slide3_right_image}
        />

        <Section2
          taste_title={taste_title}
          taste_description={taste_description}
          service_box1_image={service_box1_image}
          service_box1_title={service_box1_title}
          service_box1_description={service_box1_description}
          service_box2_image={service_box2_image}
          service_box2_title={service_box2_title}
          service_box2_description={service_box2_description}
          service_box3_image={service_box3_image}
          service_box3_title={service_box3_title}
          service_box3_description={service_box3_description}
          right_side_image1={right_side_image1}
          right_side_image2={right_side_image2}
          right_side_image3={right_side_image3}
          right_side_video_link={right_side_video_link}
        />

        <Locations />

        <Choice />
        {/* <Occasional/> */}
        
        <ProgressSection
          make_title={make_title}
          make_description={make_description}
          make_satisfied_customers={make_satisfied_customers}
          make_organic_ingredients={make_organic_ingredients}
          make_organic_skilled_icecream_artist={
            make_organic_skilled_icecream_artist
          }
          make_image1={make_image1}
          make_image1_name={make_image1_name}
          make_image2={make_image2}
          make_image2_name={make_image2_name}
        />

        {/* <Treats/> */}
        {/* <TreatsCard/> */}
        {/* <TeamMembers/> */}
        {/* <Blog/> */}
        <Testimonials testimonialsList={testimonialsList} />
        <ClientReview />
        <Timing
          unlock_title={unlock_title}
          unlock_description={unlock_description}
          unlock_left_image={unlock_left_image}
          unlock_right_image={unlock_right_image}
          unlock_app_store_link={unlock_app_store_link}
          unlock_play_store_link={unlock_play_store_link}
        />
     
      </div>
    </>
  );
};

export default HomePage;
